import React from 'react';
import {FormControlLabel, Grid, Switch, TextField} from "@mui/material";
import * as Yup from 'yup';
import {useParams} from 'react-router-dom';
import useAuth from "../../../hooks/useAuth";
import GeneralEditor from "../../../components/CrudFrom/GeneralEditor";
import localStrings from "../../../localStrings";
import {getEstablishment, saveFormEstablishment} from "../EstablishmentAddView/EstablishmentCreateUpdateForm";
import {useNavigate} from "react-router";
import {cashpad} from "./Integration";
import TextFieldPassword from "../../../components/TextFieldPassword";
import TextFieldWithCopy from "../../../components/TextFieldWithCopy";


const CashPadIntegration = ({item, saveForm}) => {
    let {establishmentId} = useParams();
    const { currentBrand } = useAuth();
    const navigate = useNavigate();
    const buildFormValues = (item) => {
        return {
            initialValues: {
                equalogLogin : item?.equalogLogin || '',
                equalogPassword : item?.equalogPassword || '',
                equalogActive : item?.cashPadActive || false,
            },
            validationSchema: {
                equalogLogin: Yup.string().max(255).required(localStrings.check.fieldRequired),
                equalogPassword: Yup.string().max(255).required(localStrings.check.fieldRequired),
            }
        };
    }



    const getCardContentForm = ({
                                    errors,
                                    handleBlur,
                                    handleChange,
                                    handleSubmit,
                                    isSubmitting,
                                    setFieldValue,
                                    touched,
                                    values
                                }) => {
        return (
            <Grid
                container
                spacing={4}
            >

                <Grid
                    item
                    md={12}
                    xs={12}
                >

                </Grid>

                <Grid
                    item
                    md={12}
                    xs={12}
                >
                    <FormControlLabel
                        // className={classes.formControl}
                        control={(
                            <Switch
                                checked={values.equalogActive}
                                edge="start"
                                name="direction"
                                onChange={() => {
                                    //alert("change ");
                                    setFieldValue('equalogActive', !values.equalogActive)
                                }}
                            />
                        )}
                        label={localStrings.active}
                    />
                </Grid>

                <Grid
                    item
                    md={12}
                    xs={12}
                >
                    <TextField
                        inputProps={{
                            autocomplete:"new-password"
                        }}
                        fullWidth
                        helperText={touched.equalogLogin && errors.equalogLogin}
                        label={localStrings.equalogLogin}
                        name="equalogLogin"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        variant="standard"
                        required
                        value={values.equalogLogin}
                    />
                </Grid>

                <Grid
                    item
                    md={12}
                    xs={12}
                >
                    <TextFieldPassword
                        inputProps={{
                            autocomplete:"new-password"
                        }}
                        fullWidth
                        helperText={touched.equalogPassword && errors.equalogPassword}
                        label={localStrings.equalogPassword}
                        name="equalogPassword"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        variant="standard"
                        required
                        value={values.equalogPassword}

                    />
                </Grid>

            </Grid>
        );
    }




    return <GeneralEditor getItemFunction={() => getEstablishment(currentBrand().id, establishmentId, true, navigate)}
                          buildFormValues={buildFormValues}
                          getCardContentForm={getCardContentForm}
                          saveForm={(item, values) => saveFormEstablishment(
                              {
                                  ...item,
                                  integrationType: cashpad
                              }, values, true, currentBrand().id, navigate)}
                          applyButton={localStrings.update}
                          messageSuccess={localStrings.notif.establishmentUpdated}
                          // titleForm={localStrings.createEstablishment : localStrings.general}
                          getPathToData={(result) => {
                              return  result.data.getEstablishment;
                          }}
    />
};

export default CashPadIntegration;
